import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";

export const Styles = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    :root {
        --color-primary: ${theme.colors.primary};
        --color-primary-dark: ${theme.colors.primaryDark};
        --color-primary-light: ${theme.colors.primaryLight};
        --color-accent: ${theme.colors.accent};
        --color-text: ${theme.colors.text};
        --color-text-secondary: ${theme.colors.textSecondary};
        --color-background-alt: ${theme.colors.backgroundAlt};
        --color-background-dark: ${theme.colors.backgroundDark};
        --color-border: ${theme.colors.border};
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    body,
    html,
    a {
        font-family: 'Inter', 'Motiva Sans Light', -apple-system, BlinkMacSystemFont, sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: ${theme.colors.background};
        overflow-x: hidden;
        color: ${theme.colors.text};
        -webkit-font-smoothing: antialiased;
    }

    a:hover {
        color: ${theme.colors.primary};
    }

    input,
    textarea {
        border-radius: ${theme.radius.sm};
        border: 1px solid ${theme.colors.border};
        background: ${theme.colors.backgroundAlt};
        transition: all 0.2s ease-in-out;
        outline: none;
        width: 100%;
        padding: 0.875rem 1rem;
        font-family: inherit;
        font-size: 0.95rem;
        color: ${theme.colors.text};

        :focus-within {
            background: ${theme.colors.background};
            border-color: ${theme.colors.primary};
            box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.12);
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Inter', 'Motiva Sans Bold', sans-serif;
        color: ${theme.colors.text};
        font-weight: 700;
        line-height: 1.25;
        letter-spacing: -0.02em;
    }

    h1 {
        font-size: clamp(2rem, 5vw, 3.25rem);
    }

    h2 {
        font-size: clamp(1.75rem, 4vw, 2.5rem);
    }

    h3 {
        font-size: clamp(1.25rem, 2.5vw, 1.5rem);
    }

    p {
        color: ${theme.colors.textSecondary};
        font-size: 1.0625rem;
        line-height: 1.7;
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${theme.colors.primary};

        :hover {
            color: ${theme.colors.primaryDark};
        }
    }

    *:focus-visible {
        outline: 2px solid ${theme.colors.primary};
        outline-offset: 2px;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
